import { useEffect } from "react";

const BASE = "Findloop";
const DEFAULT = "Findloop — Objets perdus & retrouvés";

/**
 * Sets a clean, branded browser-tab title, e.g. "Findloop | Mes annonces".
 * Restores the default title on unmount so navigation stays tidy.
 */
export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${BASE} | ${title}` : DEFAULT;
    return () => { document.title = DEFAULT; };
  }, [title]);
}

export default usePageTitle;
